import React, { useState, useCallback } from "react";
import { Button, IconButton, Menu, MenuItem, Switch } from "@mui/material";
import { usersList, ALERT, USER_TYPE } from "./constants";
import { useNavigate } from "react-router-dom";
import MoreIcon from "@mui/icons-material/MoreVert";
import { ReactComponent as Copy } from "../../assets/images/svg/copy-icon.svg";

// components
import Avatar from "../../components/common/Avatar";

import {
  actionForActiveAndDeactive,
  makeVerifiedUserRequest,
  unlockUserRequest,
} from "../../setup/api/services/user";
import DeactiveModal from "./components/DeactiveModal/DeactiveModal";

import "./styles.css";
import styles from "./user_management_styles.module.scss";
import { ROUTES } from "../../setup/constants";
import classNames from "classnames";
import moment from "moment";
import "moment/locale/ar";
import { DialogModal } from "../../components/common/dialog";
import { useTranslation } from "react-i18next";

const UserListItem = (props: any) => {
  const { item, fetchUsersList, page, alert, loading } = props;
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  // menu options
  const [modalOpen, setModalOpen] = useState(false);
  const [moreAnchorEl, setMoreAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(moreAnchorEl);
  const [userTypeAction, setUserTypeAction] = useState("");

  const handleMenuOpen = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setMoreAnchorEl(event.currentTarget);
  }, []);

  const handleMenuClose = useCallback(() => {
    setMoreAnchorEl(null);
  }, []);

  const openModal = () => {
    setModalOpen(true);
    handleMenuClose();
  };
  const closeModal = () => setModalOpen(false);

  const onMakeUserType = (type: string) => {
    setUserTypeAction(type);
    openModal();
  }

  const createRow = (desc: string, value) => {
    return { desc, value };
  };

  const sendActiveAndDeactiveApi = useCallback(
    async (item, body) => {
      loading(true);
      try {
        await actionForActiveAndDeactive(item.id, body);
        alert(ALERT.SUCCESS);
        setTimeout(() => {
          alert(ALERT.NONE);
        }, 2000);
        fetchUsersList(page);
      } catch (error) {
        alert(ALERT.ERROR);
        setTimeout(() => {
          alert(ALERT.NONE);
        }, 2000);
        console.error;
      }
      loading(false);
    },
    [alert, fetchUsersList, loading, page]
  );

  const handleActiveAndDeactiveUser = useCallback(
    async (item) => {
      if (item.enabled) {
        setShowModal(true);
      } else {
        sendActiveAndDeactiveApi(item, { active: true });
      }
    },
    [sendActiveAndDeactiveApi]
  );

  const onClose = () => {
    setShowModal(false);
  };

  const onCopy = async () => {
    try {
      await navigator?.clipboard?.writeText(
        `${item?.profile.fullName} ${item?.phoneNumber}` || ""
      );
      alert(ALERT.SUCCESS);
      setTimeout(() => {
        alert(ALERT.NONE);
      }, 2000);
    } catch (error) {
      alert(ALERT.ERROR);
      setTimeout(() => {
        alert(ALERT.NONE);
      }, 2000);
    }
  };

  const onMakeUserAction = async () => {
    try {
      await makeVerifiedUserRequest(item?.id, userTypeAction);
      alert(ALERT.SUCCESS);
    } catch (error) {
      console.error(error);
      alert(ALERT.ERROR);
    }

    closeModal();
  };

  const unlockUserAction = async () => {
    try {
      await unlockUserRequest(item?.id);
      alert(ALERT.SUCCESS);
    } catch (error) {
      console.error(error);
      alert(ALERT.ERROR);
    }
  };

  const rows = [
    createRow(
      usersList.TABLE_TTITLE_NAME,
      <div
        className={classNames(styles.row_name, styles.pointer)}
        onClick={() => navigate(`${ROUTES.STAT_USER}${item.id}`)}>
        <Avatar />
        <p className={styles.subtitle2}> {item?.profile.fullName || ""}</p>
      </div>
    ),
    createRow(
      usersList.TABLE_TTITLE_NUMBER,
      <p dir="ltr" className={styles.subtitle2}>
        {item?.phoneNumber || ""}
      </p>
    ),
    createRow(
      usersList.TABLE_TTITLE_ABSHER,
      <div>
        <span
          className={
            styles[`${`container-row-status-` + item?.nationalIdVerified}`]
          }>
          {item?.nationalIdVerified ? (
            <>
              <img src="/assets/images/svg/greenUser.svg" alt="verified" />
              <p className={classNames(styles.hint, styles.doneText)}>
                {usersList.TABLE_ACTIVE}
              </p>
            </>
          ) : (
            <>
              <img src="/assets/images/svg/redUser.svg" alt="not verified" />
              <p className={classNames(styles.hint, styles.problem)}>
                {usersList.TABLE_DEACTIVE}
              </p>
            </>
          )}
        </span>
      </div>
    ),
    createRow(
      usersList.TABLE_TTITLE_STATUS,
      <div>
        <span className={styles[`${`container-row-status-` + item?.enabled}`]}>
          {item?.enabled ? (
            <>
              <img src="/assets/images/svg/greenUser.svg" alt="verified" />
              <p className={classNames(styles.hint, styles.doneText)}>
                {usersList.TABLE_ACTIVE}
              </p>
            </>
          ) : (
            <>
              <img src="/assets/images/svg/redUser.svg" alt="not verified" />
              <p className={classNames(styles.hint, styles.problem)}>
                {usersList.TABLE_DEACTIVE}
              </p>
            </>
          )}
        </span>
      </div>
    ),
    createRow(
      usersList.TABLE_TTITLE_NUMBER,
      <p dir="ltr" className={styles.subtitle2}>
        {item?.createdAt
          ? moment(item?.createdAt).locale("ar").format(`DD MMMM YYYY - hh:mm`)
          : ""}
      </p>
    ),
    createRow(
      "",
      <Switch
        checked={item?.enabled}
        onChange={() => handleActiveAndDeactiveUser(item)}
        defaultChecked
      />
    ),
    createRow(
      usersList.TABLE_TTITLE_STATUS,
      <div
        onClick={onCopy}
        className={classNames(styles["copy_icon"], styles["pointer"])}>
        <span>
          <Copy />
        </span>
      </div>
    ),
    createRow(
      "",
      <>
        <IconButton
          size="large"
          aria-label="show more"
          aria-controls={"ContractActions"}
          aria-haspopup="true"
          onClick={handleMenuOpen}
          color="inherit">
          <MoreIcon />
        </IconButton>
        <Menu
          anchorEl={moreAnchorEl}
          dir="rtl"
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          id={item?.id}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={isMenuOpen}
          onClose={handleMenuClose}>
          <MenuItem onClick={() => handleActiveAndDeactiveUser(item)}>
            <p>{item.enabled ? t("lbl_disable_user_btn") : t("lbl_enable_user_btn")}</p>
          </MenuItem>
          {!item?.accountNonLocked && (
            <MenuItem onClick={unlockUserAction}>
              <p>{t("lbl_unlock_user_btn")}</p>
            </MenuItem>
          )}
          {!item?.profile?.brokerVerified && (
            <MenuItem onClick={() => onMakeUserType(USER_TYPE.BROKER)}>
              <p>{usersList?.MAKE_USER_BROKER}</p>
            </MenuItem>
          )}
          {!item?.profile?.complexCreatorVerified && (
            <MenuItem onClick={() => onMakeUserType(USER_TYPE.COMPLEX_CREATOR)}>
              <p>{t("lbl_make_user_complex_creator")}</p>
            </MenuItem>
          )}
        </Menu>
      </>
    ),
  ];

  return (
    <>
      <tr className={styles.table_row}>
        {rows.map((row, index) => (
          <td className={styles.table_value} key={index}>
            {row.value}
          </td>
        ))}
      </tr>
      <DeactiveModal
        showModal={showModal}
        onClose={onClose}
        onClickDone={(body) => sendActiveAndDeactiveApi(item, body)}
      />
      <DialogModal
        title={userTypeAction === USER_TYPE.BROKER ? usersList?.CONFIRM_CHANGE_TO_BROKER : t("lbl_confirm_change_to_complex_creator")}
        open={modalOpen}
        handleClose={closeModal}>
        <div className={styles["button_group"]}>
          <Button variant="contained" onClick={onMakeUserAction}>
            {t("lbl_confirm")}
          </Button>
          <Button onClick={closeModal}>{t("lbl_cancel")}</Button>
        </div>
      </DialogModal>
    </>
  );
};
export default UserListItem;
